import { useEffect, useState, useCallback } from "react";
import DrawerChooseLocation from "./DrawerChooseLocation";
import DrawerSpontaneousApplication from "./DrawerSpontaneousApplication";
import DrawerSummerCamp from "./DrawerSummerCamp";
import DrawerBecomeDistributor from "./DrawerBecomeDistributor";

export default function AppDrawers({ pageProps }) {
  const [openRegion, setOpenRegion] = useState(false);
  const [openApplication, setOpenApplication] = useState(false);
  const [openSummerCamp, setOpenSummerCamp] = useState(false);
  const [openDistributor, setOpenDistributor] = useState(false);

  // Capture all events on the website
  useEffect(() => {
    const handleRegionSelection = () => {
      setOpenRegion(true);
    };

    const handleSpontaneousApplication = () => {
      setOpenApplication(true);
    };

    const handleSummerCamp = () => {
      setOpenSummerCamp(true);
    };

    const handleBecomeDistributor = () => {
      setOpenDistributor(true);
    };

    window.addEventListener("openRegionSelection", handleRegionSelection);
    window.addEventListener(
      "openSpontaneousApplication",
      handleSpontaneousApplication
    );
    window.addEventListener("openSummerCamp", handleSummerCamp);
    window.addEventListener("openBecomeDistributor", handleBecomeDistributor);

    return () => {
      window.removeEventListener("openRegionSelection", handleRegionSelection);
      window.removeEventListener(
        "openSpontaneousApplication",
        handleSpontaneousApplication
      );
      window.removeEventListener("openSummerCamp", handleSummerCamp);
      window.removeEventListener("openSummerCamp", handleBecomeDistributor);
    };
  }, []);

  return (
    <>
      <DrawerChooseLocation
        global_link={pageProps.global_website}
        regions={pageProps.regions}
        open={openRegion}
        setOpen={setOpenRegion}
        translations={pageProps.translations}
        websiteType={pageProps.websiteType}
      />
      <DrawerSpontaneousApplication
        open={openApplication}
        setOpen={setOpenApplication}
        translations={pageProps.translations}
      />
      <DrawerSummerCamp
        open={openSummerCamp}
        setOpen={setOpenSummerCamp}
        translations={pageProps.translations}
      />
      <DrawerBecomeDistributor
        locale={pageProps.locale}
        open={openDistributor}
        setOpen={setOpenDistributor}
        translations={pageProps.translations}
      />
    </>
  );
}
